// Read-time compatibility only. Existing stored reports are never rewritten.
export const normalizeSynthesisPoints = (points) => {
  if (!Array.isArray(points)) return [];
  return points
    .filter((point) => point && typeof point === 'object')
    .map((point) => ({
      ...point,
      title: typeof point.title === 'string' ? point.title : '',
      content: typeof point.content === 'string' ? point.content : '',
    }));
};
